import { createDraftSafeSelector as createSelector } from '@reduxjs/toolkit';

import { Inject } from '@vk-hr-tek/core/ioc';

import { RootState } from '../../app/store';
import { LayoutMapper, SideMenuMapper } from '../mappers';

export const selectServiceUnavailable = (state: RootState) =>
  state.layout.isServiceUnavailable;

export const selectRefreshing = (state: RootState) => state.layout.isRefreshing;

export const selectSidebarState = (state: RootState) =>
  state.layout.sidebarState;

export const selectIsLogoLoaded = (state: RootState) =>
  state.layout.isLogoLoaded;

export const selectSearchStatus = (state: RootState) =>
  state.layout.search.status;

export const selectSearchError = (state: RootState) =>
  state.layout.search.error;

export const selectSearchItems = createSelector(
  [
    (state: RootState) => state.layout.search.items,
    (state: RootState) => state.layout.search.group,
    (_: RootState, inject: Inject) => inject(LayoutMapper),
  ],
  (searchItems, group, format) => {
    return searchItems ? format.processSearchItems(searchItems, group) : [];
  },
);

export const selectSideMenu = createSelector(
  [
    (state: RootState) => state.layout.sideMenuState?.menu,
    (_: RootState, inject: Inject) => inject(SideMenuMapper),
  ],
  (sideMenu, mapper) => {
    return sideMenu && mapper.processSideMenu(sideMenu);
  },
);

export const selectSearchGroups = createSelector(
  [
    (state: RootState) => state.layout.groups.items,
    (_: RootState, inject: Inject) => inject(LayoutMapper),
  ],
  (groups, mapper) => {
    return mapper.processSearchGroups(groups);
  },
);
